"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTwoArrayIdentical = exports.convertArrayToObject = exports.isEmptyArray = void 0;
const isEmptyArray = (dataSource) => {
    return dataSource.length === 0;
};
exports.isEmptyArray = isEmptyArray;
/**
 * 轉換物件陣列為兩層物件
 *
 * getKey 為擷取子物件的某一個屬性作為父物件的屬性值
 */
const convertArrayToObject = (array = [], getKey) => array.reduce((object, current) => {
    const key = getKey(current);
    return Object.assign(Object.assign({}, object), { [key]: current });
}, {});
exports.convertArrayToObject = convertArrayToObject;
const isTwoArrayIdentical = (array1, array2) => {
    if (array1.length !== array2.length)
        return false;
    const sortedArray1 = array1.sort((a, b) => a.localeCompare(b));
    const sortedArray2 = array2.sort((a, b) => a.localeCompare(b));
    for (let i = 0; i < sortedArray1.length; i++) {
        if (sortedArray1[i] !== sortedArray2[i])
            return false;
    }
    return true;
};
exports.isTwoArrayIdentical = isTwoArrayIdentical;
